// @ts-nocheck
import {useEffect, useMemo, useState} from 'react'
import {useTable, ColumnInstance, Row} from 'react-table'
import {CustomHeaderColumn} from './columns/CustomHeaderColumn'
import {CustomRow} from './columns/CustomRow'
import {useQueryResponseData, useQueryResponseLoading} from '../core/QueryResponseProvider'
import {adsColumns} from './columns/_columns'
import {User} from '../core/_models'
import {UsersListLoading} from '../components/loading/ReportsListLoading'
import {UsersListPagination} from '../components/pagination/AdsListPagination'
import {KTCardBody} from '../../../../../_metronic/helpers'
import {useGetAllAdsPaginationQuery, useGetAllAdsQuery} from '../../../../../api'
import useFetchAdvertisement from '../../../../hooks/useFetchAdvertisement'
import useFetchReports from '../../../../hooks/useFetchReports'

type SearchProps = {
  adSearch: String
  setAdSearch: Function
}

export let AllUsersData

const ReportsTable = ({adSearch, category, status, page, setPage, sDate, eDate}: SearchProps) => {
  const {reports, pagination, error, loading, refetchReports} = useFetchReports(
    page,
    status,
    category,
    sDate,
    eDate,
    adSearch
  )

  console.log(category, 'category')
  useEffect(() => {
    refetchReports()
  }, [page, status, category, status, sDate, eDate, adSearch])
  console.log(reports, 'reports')
  const data = useMemo(() => reports, [reports])
  const columns = useMemo(() => adsColumns, [])
  const {getTableProps, getTableBodyProps, headers, rows, prepareRow} = useTable({
    columns,
    data,
  })
  return (
    <KTCardBody className='py-4'>
      <div className='table-responsive'>
        <table
          id='kt_table_users'
          className='table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer'
          {...getTableProps()}
        >
          <thead>
            <tr className='text-start text-muted fw-bolder fs-7 text-uppercase gs-0'>
              {headers.map((column: ColumnInstance<User>) => (
                <CustomHeaderColumn key={column.id} column={column} />
              ))}
            </tr>
          </thead>
          <tbody className='text-gray-600 fw-bold' {...getTableBodyProps()}>
            {rows.length > 0 ? (
              rows.map((row: Row<User>, i) => {
                prepareRow(row)
                return <CustomRow row={row} key={`row-${i}-${row.id}`} />
              })
            ) : (
              <tr>
                <td colSpan={7}>
                  <div className='d-flex text-center w-100 align-content-center justify-content-center'>
                    No matching records found
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <UsersListPagination
        page={page}
        setPage={setPage}
        totalPages={page + 5 < pagination.totalPages ? page + 5 : pagination.totalPages}
        loading={loading}
        paginationDetails={pagination}
      />
      {loading && <UsersListLoading />}
      {loading && <UsersListLoading />}
    </KTCardBody>
  )
}

export {ReportsTable}
